module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.4-update-card-procedure.f1b26b91.png";